// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"822851a5","239":"fc5253b0","455":"1acf2b0c"}[chunkId] + ".chunk.js";
};